<script>
import { _request } from '@/helpers/_request'
import Parser from '@/helpers/_responseParser'

export default {
  name: 'UserService',
  methods: {
    getUser () {
      return _request('GetUserProfile').then(Parser.toXml.bind(null, 'GetUserProfileResponse'))
    },
    initiatePhoneVerification () {
      return _request('InitiatePhoneVerification').then(Parser.toXml.bind(null, 'InitiatePhoneVerificationResponse'))
    },
    completePhoneVerification (vereficationNumber) {
      return _request('CompletePhoneVerification', {
        VerificationCode: vereficationNumber
      }).then(Parser.toXml.bind(null, 'CompletePhoneVerificationResponse'))
    },
    changePassword (changePasswordData) {
      return _request('ChangePassword', changePasswordData).then(Parser.toXml.bind(null, 'ChangePasswordResponse'))
    },
    updateUserMobileNumber (userCredential) {
      return _request('UpdateUserProfile2', {
        UserProfile: {
          MobileNumber: '+' + (userCredential.mobileNumber.firstPart + userCredential.mobileNumber.secondPart).match(/[0-9]+/g).join('')
        },
        ForceUpdate: true
      }).then(Parser.toXml.bind(null, 'UpdateUserProfileResponse2'))
    },
    updateUserProfile (userCredential, SessionId, ForceUpdate) {
      if (userCredential.UserIdNumber) {
        userCredential.idNumber = userCredential.UserIdNumber
      }
      return _request('UpdateUserProfile2', {
        UserProfile: {
          LastName: userCredential.lastName,
          StreetAddress1: userCredential.streetAddress1,
          MobileNumber: '+' + (userCredential.mobileNumber.firstPart + userCredential.mobileNumber.secondPart).match(/[0-9]+/g).join(''),
          DateOfBirth: `${userCredential.dateOfBirth.month}/${userCredential.dateOfBirth.day}/${userCredential.dateOfBirth.year}`,
          City: userCredential.city,
          // sIdExpiry: userCredential.sIdExpiry,
          State: userCredential.state,
          CustomProperties: [
            {
              Name: 'UserIdType',
              Value: userCredential.idType || userCredential.UserIdType || userCredential.UserIdTypeId ? [userCredential.idType, userCredential.UserIdType, userCredential.UserIdTypeId].includes('Driving license') ? 1 : 2 : null
            },
            {
              Name: 'UserIdNumber',
              Value: userCredential.idNumber || userCredential.UserIdNumber
            },
            {
              Name: 'sOccupation',
              Value: userCredential.sOccupation
            },
            {
              Name: 'sIdExpiry',
              Value: userCredential.sIdExpiry ? typeof userCredential.sIdExpiry === 'object' ? ![userCredential.sIdExpiry.day, userCredential.sIdExpiry.month, userCredential.sIdExpiry.year].includes('Invalid date') ? `${userCredential.sIdExpiry.month}/${userCredential.sIdExpiry.day}/${userCredential.sIdExpiry.year}` : '' : userCredential.sIdExpiry : ''
            },
            {
              Name: 'SenderPlaceofBirth',
              Value: userCredential.SenderPlaceofBirth
            }
          ].filter(customProp => customProp.Value),
          // sOccupation: userCredential.sOccupation,
          MiddleName: userCredential.middleName,
          FirstName: userCredential.firstName,
          StreetAddress2: userCredential.streetAddress2,
          EmailAddress: userCredential.emailAddress,
          PostalCode: userCredential.postalCode ? userCredential.postalCode.replace(/\s+/g, '') : 'M2J3C4'
        },
        ForceUpdate,
        SessionId
      })
        .then(Parser.toXml.bind(null, 'UpdateUserProfileResponse2'))
    },
    postSurvey (data) {
      return _request('PostSurvey', data).then(Parser.toXml.bind(null, 'PostSurveyResponse'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/UserService.vue